module.exports = __webpack_public_path__ + "media/npc_dota_hero_omniknight.09434338.webm";